import React, { type FC, memo } from "react";
import { getDetailedGrade, isSingle } from "../../compareUtils";
import PacksSingle from "./PacksSingle";
import PacksMultiple from "./PacksMultiple";
import { useGetCompareGrades } from "../../compareHooks";
import SectionCollapse from "../SectionCollapse";
import { CollapseSection, trackExpandedItem } from "../../../../../../utils/tracking";
import { useCompareContext } from "../../CompareContext";
import { selectCompareSpecs } from "../../../../../../redux/slices/CarConfigCompareSpecsSlice";
import { useCarConfigSelector } from "../../../../../../redux/store";
import { useCarConfigLabel } from "../../../../../../utils/labelUtils";
import { TsBoolean } from "../../../../../../../../../shared-logic/utils/commonUtils";

const Packs: FC = () => {
    const { openedCollapses, setOpenedCollapses } = useCompareContext();
    const grades = useGetCompareGrades();
    const isSingleGrade = isSingle(grades);

    const compareSpecsGrades = useCarConfigSelector(selectCompareSpecs);
    const detailedGradesList = (grades || [])
        .map((grade) => getDetailedGrade(compareSpecsGrades, grade))
        .filter(TsBoolean);
    const compareHasPacks = detailedGradesList.some((grade) => grade.packs && grade.packs.length > 0);

    const carConfigLbxComparePacks = useCarConfigLabel("carConfigLbxComparePacks");

    if (!compareHasPacks) return null;
    return (
        <SectionCollapse
            open={openedCollapses.includes(CollapseSection.SectionPacks)}
            onChange={() => {
                const isOpen = openedCollapses.includes(CollapseSection.SectionPacks);

                trackExpandedItem(isOpen, CollapseSection.SectionPacks);

                setOpenedCollapses(
                    isOpen
                        ? openedCollapses.filter((item) => item !== CollapseSection.SectionPacks)
                        : [...openedCollapses, CollapseSection.SectionPacks],
                );
            }}
            summary={carConfigLbxComparePacks}
        >
            {isSingleGrade ? <PacksSingle /> : <PacksMultiple />}
        </SectionCollapse>
    );
};

export default memo(Packs);
